import { Controller } from "@hotwired/stimulus"

// Manages the checkout coupon form overlay and button state during submission.
export default class extends Controller {
  static targets = ["overlay", "submit", "message"]
  static values = {
    defaultMessage: String,
    applyMessage: String,
    removeMessage: String
  }

  show(event) {
    const action = event?.target?.dataset?.couponAction
    const overlayMessage = this.messageFor(action)

    if (this.hasMessageTarget && overlayMessage) {
      this.messageTarget.textContent = overlayMessage
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
    }
  }

  hide(event) {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }

    // Reset the input on success when the server cleared the coupon field.
    if (event && event.detail && event.detail.success) {
      const form = event.target
      if (form instanceof HTMLFormElement) {
        const input = form.querySelector("input[name='coupon_code']")
        if (input && !input.value?.trim()) {
          input.value = ""
        }
      }
    }
  }

  messageFor(action) {
    if (action === "remove") {
      return this.removeMessageValue || "Removing coupon…"
    }
    if (action === "apply") {
      return this.applyMessageValue || "Applying coupon…"
    }
    return this.defaultMessageValue || "Processing coupon…"
  }
}
